var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0501 6.45225L26.05 6.45947V6.46668V8.03334C26.05 8.93825 25.3216 9.66668 24.4167 9.66668H16.5667C15.6618 9.66668 14.9333 8.93825 14.9333 8.03334V6.46668C14.9333 5.57211 15.668 4.83334 16.5833 4.83334H24.4167C25.3349 4.83334 26.0585 5.57176 26.0501 6.45225Z",
    fill: "#56A10E",
    stroke: "#56A10E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4167 14.35C27.7451 14.35 30.4874 11.7512 30.7177 8.47954C32.3992 9.53006 33.5167 11.4039 33.5167 13.5333V29.2167C33.5167 32.4882 30.8382 35.1667 27.5667 35.1667H13.4333C10.1618 35.1667 7.48333 32.4882 7.48333 29.2167V13.5333C7.48333 11.4039 8.6008 9.53006 10.2823 8.47954C10.5126 11.7512 13.2549 14.35 16.5833 14.35H24.4167ZM20.4607 28.944L27.1273 22.2773C28.1964 21.2082 28.1964 19.4585 27.1273 18.3893C26.0582 17.3202 24.3085 17.3202 23.2393 18.3893L18.5167 23.112L17.9607 22.556C16.8915 21.4869 15.1418 21.4869 14.0727 22.556C13.0036 23.6251 13.0036 25.3749 14.0727 26.444L16.5727 28.944C17.1188 29.4901 17.8236 29.75 18.5167 29.75C19.2097 29.75 19.9145 29.4901 20.4607 28.944Z",
    fill: "#56A10E",
    stroke: "#56A10E",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardTick);
export default __webpack_public_path__ + "static/media/clipboard-tick.3f38e71263b3e72e1b6735cca1e97110.svg";
export { ForwardRef as ReactComponent };